export const LinksDeleteMessage = ({ messageWithLinks }: any) => {
  return (
    <span style={{ fontSize: '14px', fontWeight: 400, color: 'rgba(0, 0, 0, 0.6)' }}>
      {messageWithLinks.header}
      <br />
      <ul>
        {messageWithLinks.links && <li>{messageWithLinks.links}</li>}
        {messageWithLinks.relatedTopics && <li>{messageWithLinks.relatedTopics}</li>}
        {messageWithLinks.followers && <li>{messageWithLinks.followers}</li>}
      </ul>
      {messageWithLinks.footer}
    </span>
  );
};
